import { render, staticRenderFns } from "./Sjy.vue?vue&type=template&id=7053f717&scoped=true&"
import script from "./Sjy.vue?vue&type=script&lang=js&"
export * from "./Sjy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7053f717",
  null
  
)

export default component.exports